<template>
    <div class="ocr-box flex-between">
        <div class="work-box">
            <el-tabs v-model="activeName">
                <el-tab-pane label="作业识别" name="1">
                    <div class="content" v-if="ocrlist.length > 0">
                        <div class="userinfo flex-align">
                            <img class="avatar" :src="downloadURL + userinfo.avatar"
                                :onerror="$store.state.user.defaultAvatar" alt="">
                            <div class="info flex-column">
                                <span>{{ userinfo.name }}</span>
                                <span>提交于{{ userinfo.time }}</span>
                            </div>
                        </div>
                        <div class="work-item flex-column" v-for="(item, index) in ocrlist" :key="index">
                            <span>{{ index + 1 }}.{{ item.title }}</span>
                            <template v-for="(items, indexs) in item.answerFile">
                                <img :src="downloadURL + items.fileUrl" alt="">
                                <div class="ocr-content flex-column" v-if="userinfo.status==1">
                                    <el-button type="text" @click="edit(index, indexs)">编辑</el-button>
                                    <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" placeholder="请输入内容"
                                        v-model="items.resule" :readonly="items.readonly">
                                    </el-input>
                                    <div class="btn-box flex-align" v-if="!items.readonly">
                                        <el-button type="primary" size="small" plain
                                            @click="save(index, indexs, items.id)">保存</el-button>
                                        <el-button type="info" size="small" plain
                                            @click="items.readonly = true">取消</el-button>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <template v-else>
                        <el-empty description="暂无内容"></el-empty>
                    </template>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="stu-box flex-column">
            <div class="total flex-align-between">
                <span>已交学员 {{ total }}</span>
                <el-input placeholder="搜索" suffix-icon="el-icon-search" size="small" v-model="input" @change="inputChange">
                </el-input>
            </div>
            <div class="menu flex-align">
                <span v-for="(item, index) in menus" :key="index" @click="changeStatus(item.status, index)"
                    :class="{ 'active': defaultIndex == index }">{{ item.text }}</span>
            </div>
            <template v-if="stuList.length > 0">
                <div class="stulist flex-column-center">
                    <div class="stuitem flex-align" v-for="(item, index) in stuList" :key="index"
                        @click="changeStu(item, index)" :class="{ 'active': stuIndex == index }">
                        <span>{{ index + 1 }}</span>
                        <img :src="downloadURL + item.avatar" :onerror="$store.state.user.defaultAvatar" alt="">
                        <span>{{ item.name }}</span>
                        <span class="ocr" v-if="defaultIndex == 2"
                            @click="startRecognize(item.userId, item.bindId)">OCR识别</span>
                    </div>
                </div>
                <div class="page">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :pager-count="5"
                        :current-page.sync="page" :page-size="limit" layout="prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </template>
            <template v-else>
                <el-empty description="暂无内容"></el-empty>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            activeName: "1",
            input: '',
            menus: [
                { text: '全部', status: '' },
                { text: '已识别', status: 1 },
                { text: '未识别', status: 0 },
                { text: '已提交', status: 3 },
                { text: '未提交', status: 2 },
            ],
            defaultIndex: 0,
            stuIndex: 0,
            currentPage: 1,
            textarea: '',
            readonly: true,
            page: 1,
            limit: 10,
            total: 0,
            stuList: [],
            status: '',// 全部'' 已识别0 未识别1 未提交2或者null
            userinfo: {
                name: '',
                time: ''
            },
            title: '', // 作业题目
            ocrlist: [],// 识别出来的数据
        }
    },
    methods: {
        changeStatus(status, index) {
            this.stuIndex = 0;
            this.page = 1;
            this.defaultIndex = index;
            this.status = status;
            this.getOneList();
        },
        changeStu(item, index) {
            this.userinfo = item;
            this.stuIndex = index;
            this.getOneListDetail(item.userId, item.bindId)
        },
        handleSizeChange() { },
        handleCurrentChange(page) {
            this.page = page;
            this.getOneList()
        },
        edit(index, indexs) {
            this.ocrlist[index].answerFile[indexs].readonly = false;
        },
        save(index, indexs, id) {
            this.ocrlist[index].answerFile[indexs].readonly = true;
            this.editOcrResult(id, this.ocrlist[index].answerFile[indexs].resule)
        },
        async getOneList() {
            let data = {
                ocrId: this.$route.query.ocrId,
                page: this.page,
                limit: this.limit,
                key: this.input,
                type: 0,
                status: this.status
            }
            let resData = await this.$Api.ocr.getOneList(data);
            this.total = resData.data.total;
            this.stuList = resData.data.records;
            if (this.stuList.length > 0) {
                this.userinfo = this.stuList[0];
                this.getOneListDetail(this.userinfo.userId, this.userinfo.bindId);
            } else {
                this.userinfo = {
                    name: '',
                    time: ''
                }
                this.ocrlist = []
            }
        },
        async getOneListDetail(userId) {
            let data = {
                userId,
                bindId: this.$route.query.bindId
            }
            let resData = await this.$Api.ocr.getOneListDetail(data)
            console.log('单个学员详情:', resData);
            if (resData.data) {
                if (resData.data.length > 0) {
                    this.userinfo.time = resData.data[0].createTime;
                    resData.data.map(item => {
                        item.answerFile.map(items => {
                            items.readonly = true
                        })
                    })
                }
                this.ocrlist = resData.data;
            } else {
                this.ocrlist = []
            }

        },
        async editOcrResult(id, resule) {
            let data = {
                id,
                resule
            }
            let resData = await this.$Api.ocr.editOcrResult(data)
            console.log('编辑识别内容:', resData);
        },
        inputChange(val) {
            this.input = val;
            this.getOneList()
        },
        async startRecognize(userId,bindId) {
            let data = {
                userId,
                bindId
            }
            let resData = await this.$Api.ocr.startRecognizeOne(data)
            console.log('单个开始识别:', resData);
        }
    },
    mounted() {
        this.getOneList()
    }
}
</script>
<style lang="less" scoped>
.ocr-box {
    width: 1200px;
    min-height: 500px;
    margin: 0 auto;

    .work-box {
        width: 850px;
        margin: 0 auto 100px;
        background-color: #ffffff;
        box-shadow: 0px 2px 10px 0px #f5f8fa;
        border-radius: 8px;

        .content {
            box-sizing: border-box;
            padding: 20px 40px;

            .userinfo {
                margin-bottom: 30px;

                .avatar {
                    width: 45px;
                    height: 45px;
                    border-radius: 50%;
                    margin-right: 30px;
                }

                .info {
                    span:first-child {
                        color: #333333;
                        font-size: 16px;
                    }

                    span:last-child {
                        color: #666666;
                        font-size: 12px;
                    }
                }
            }

            .work-item {
                span {
                    color: #333333;
                    font-size: 14px;
                }

                img {
                    width: 300px;
                    margin: 20px 0;
                }

                .ocr-content {
                    width: 100%;
                    // border: 1px solid #1B71F4;
                    border-radius: 5px;

                    .el-button {
                        margin-left: auto;
                    }

                    /deep/ textarea {
                        overflow-y: auto;
                    }

                    .btn-box {
                        margin: 10px auto 0;

                        .el-button {
                            margin-right: 20px;
                        }
                    }
                }
            }
        }
    }

    .stu-box {
        width: 320px;
        margin: 0 auto 100px;
        background-color: #ffffff;
        box-shadow: 0px 2px 10px 0px #f5f8fa;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 20px 20px;

        .total {
            margin-bottom: 20px;

            .el-input {
                width: 150px;
            }
        }

        .menu {
            font-size: 14px;
            color: #333333;
            box-sizing: border-box;
            padding-bottom: 8px;
            border-bottom: 1px solid #F5F4F4;
            margin-bottom: 20px;

            span {
                cursor: pointer;
                display: flex;
                margin-right: 15px;
            }

            & .active {
                color: #1B71F4;
            }
        }

        .stulist {
            .stuitem {
                cursor: default;
                color: #333333;
                font-size: 14px;
                width: 100%;
                height: 60px;
                border-radius: 5px;
                margin-bottom: 10px;
                box-sizing: border-box;
                padding: 0 10px;

                span:first-child {
                    width: 20px;
                }

                .ocr {
                    margin-left: auto;
                    color: #1B71F4;
                    cursor: pointer;
                }

                img {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    margin: 0 10px;
                }

                &:hover {
                    background-color: #FAFAFA;
                }
            }

            .active {
                background-color: #FAFAFA;
            }
        }

        .page {
            width: 100%;
            display: flex;
            justify-content: space-around;
            margin-top: auto;

            /deep/ .el-pagination {
                width: 100%;
                text-align: center;
            }

            /deep/ .el-pagination__jump {
                display: block;
                text-align: center;
                margin-left: 0;
                margin-top: 10px;
            }
        }
    }

}
</style>